import Vue from 'vue';
import Vuex from 'vuex';
import issues from '@mobile/store/issues';
import state from '@mobile/store/state';
import checklists from '@mobile/store/checklists';
import inspections from '@mobile/store/inspections';
import drafts from '@mobile/store/drafts';
import todos from '@mobile/store/todos';
import conduct from '@mobile/store/conduct';
import connection from '@mobile/store/connection';
import authentication from '@mobile/store/authentication';
import sync from '@mobile/store/sync';
import profile from '@mobile/store/profile';
import notifications from '@mobile/store/notifications';
import actions from '@mobile/store/actions';
import mutations from '@mobile/store/mutations';
import getters from '@mobile/store/getters';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,

    modules: {
        authentication,
        checklists,
        inspections,
        drafts,
        todos,
        conduct,
        connection,
        sync,
        profile,
        notifications,
        issues,
    },
});
